var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.96,
    cy: 19.76,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.92,17.11c-1.46,0-2.65,1.19-2.65,2.65s1.19,2.65,2.65,2.65,2.65-1.19,2.65-2.65-1.19-2.65-2.65-2.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.88,
    cy: 19.76,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.5,0C14.43,0,0,10.12,0,22.1c0,10.17,10.66,18.97,25.34,20.92.1.01.21.02.31.02,1.09,0,2.02-.82,2.16-1.91.16-1.2-.69-2.31-1.89-2.47-12.47-1.66-21.52-8.62-21.52-16.56,0-9.43,12.67-17.7,27.11-17.7s27.11,8.27,27.11,17.7c0,1.32-.25,2.65-.75,3.92-.49,1.26-1.2,2.47-2.1,3.61-.49.61-1.01,1.18-1.55,1.68l-.06.06v-.08c.05-.27.08-.55.09-.83.13-2.4-.84-4.71-2.66-6.34-1.5-1.35-3.43-2.09-5.43-2.09-.43,0-.87.03-1.3.1-2.1.35-4.01,1.51-5.39,3.27-1.71,2.17-2.3,5.23-1.55,8,.67,2.47,2.35,4.4,4.61,5.29.4.16.83.29,1.3.4h.06s-.05.05-.05.05c-2.4,1.95-4.98,3.47-6.96,4.58-2.27,1.27-4.3,2.27-6.21,3.06-1.12.47-1.65,1.75-1.19,2.87.34.82,1.14,1.36,2.03,1.36.28,0,.57-.06.84-.17,2.09-.87,4.27-1.94,6.67-3.28,3.49-1.95,7.95-4.7,11.39-8.65.08-.09.28-.33.34-.4.25-.09.49-.18.73-.28,2.96-1.21,5.63-3.23,7.72-5.85,1.18-1.48,2.11-3.08,2.76-4.75.7-1.79,1.05-3.65,1.05-5.52C63,10.12,48.58,0,31.5,0ZM48.12,34.68h0s-.01.01-.01.01c-.7.16-1.36.24-1.98.24-.75,0-1.42-.12-2.01-.35-1.24-.48-1.76-1.54-1.97-2.35-.39-1.42-.09-3.05.76-4.13.69-.88,1.65-1.48,2.65-1.64.2-.03.39-.05.59-.05.91,0,1.79.34,2.49.97.82.74,1.26,1.77,1.2,2.84-.07,1.39-.67,2.93-1.72,4.46Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.7a126d37ef303890e7d07557f2b088e9.svg";
export { ForwardRef as ReactComponent };